module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4gDRa"))).then(() => parcelRequire('d0iPb'));